/* eslint-disable no-else-return */
/* eslint-disable camelcase */
/* eslint-disable global-require */
import moment from "moment";
import { ROUTES } from "src/config/user-authorization";
import { Utility } from "./utility";
import visitRescheduleSvg from "src/assets/notifications/visit_reschedule.svg";
import collegeFairSvg from "src/assets/notifications/college_fair.svg";
import visitPendingSvg from "src/assets/notifications/visit_pending.svg";
import visitCancelSvg from "src/assets/notifications/visit_cancel.svg";
import visitConfirmSvg from "src/assets/notifications/visit_confirm.svg";
import programActiveSvg from "src/assets/notifications/program_active.svg";
import programDeclinedSvg from "src/assets/notifications/program_declined.svg";
import applicationNewSvg from "src/assets/notifications/application_new_application.svg";
import applicationUpdateSvg from "src/assets/notifications/application_update_application.svg";
import applicationWithdrawSvg from "src/assets/notifications/application_withdraw_application.svg";
import connectionSvg from "src/assets/notifications/connection.svg";

const isNonEmptyString = Utility.isNonEmptyString;

const IMAGE_NAMES = {
  visit_reschedule: visitRescheduleSvg,
  college_fair: collegeFairSvg,
  visit_pending: visitPendingSvg,
  visit_cancel: visitCancelSvg,
  visit_confirm: visitConfirmSvg,
  program_active: programActiveSvg,
  program_declined: programDeclinedSvg,
  application_new_application: applicationNewSvg,
  application_update_application: applicationUpdateSvg,
  application_withdraw_application: applicationWithdrawSvg,
  connection: connectionSvg,
};

export class AppNotification {
  static getLink(notification = {}) {
    const { application_id, event_id, notification_type } =
      notification;

    if (notification_type === "Event") {
      return `/events/${event_id}`;
    } else if (notification_type === "StudentApplication") {
      return `/direct-apply/applications/${application_id}`;
    } else if (notification_type === "PartnerProgram") {
      return `/direct-apply/programs`;
    } else if (notification_type === "WebinarCategory") {
      return `/event/cialfo-events`;
    }
    if (notification_type === "Connection") {
      return ROUTES.CONNECTIONS;
    } else {
      return "/notifications";
    }
  }

  static getHeader(notification = {}) {
    const { message, fair_name, notification_type } = notification;

    if (
      notification_type === "Event" ||
      notification_type === "StudentApplication" ||
      notification_type === "PartnerProgram" ||
      notification_type === "Connection"
    ) {
      return isNonEmptyString(message) ? message : "";
    } else if (notification_type === "WebinarCategory") {
      return isNonEmptyString(fair_name) ? fair_name : "";
    } else {
      return "";
    }
  }

  static getBody(notification = {}, isSchool = false) {
    const {
      institute_name,
      program_name,
      notification_type,
      partner_university,
      partner_school,
      participate_by,
      sub_message,
    } = notification;

    if (notification_type === "StudentApplication") {
      return isNonEmptyString(institute_name) ? institute_name : "";
    } else if (notification_type === "PartnerProgram") {
      return isNonEmptyString(program_name) ? program_name : "";
    } else if (notification_type === "Event") {
      return isSchool ? partner_university : partner_school;
    } else if (notification_type === "WebinarCategory") {
      return `Participate by ${moment(participate_by).format(
        "DD MMM, YYYY",
      )}.`;
    } else if (notification_type === "Connection") {
      return isNonEmptyString(sub_message) ? sub_message : "";
    } else {
      return "";
    }
  }

  static hasParticipationDateExpired(date = undefined) {
    return moment().format(date) < moment().format();
  }

  static getImageName(notification = {}) {
    const { image_name } = notification;

    if (IMAGE_NAMES[image_name]) {
      return IMAGE_NAMES[image_name];
    }

    return "application_new_application"; // need to have a default image in case image name is not found/incorrect.
  }
}
